import * as React from 'react';
import { Spinner } from '@cian/ui-kit';
import * as styles from './PublishTermsLoader.css';

interface IPublishTermsLoader {
  isMobile: boolean;
}

export const PublishTermsLoader = ({ isMobile }: IPublishTermsLoader) => {
  return (
    <div className={styles['wrapper']}>
      <Spinner size={isMobile ? 30 : 50} />
    </div>
  );
};
